import { c as _c } from "react/compiler-runtime";
import { IconInfoCircle } from "@tabler/icons-react";
import { Card, CardContent, CardDescription, CardTitle } from "@domainstack/ui/card";
import { Icon } from "@domainstack/ui/icon";
import { ResponsiveTooltip, ResponsiveTooltipContent, ResponsiveTooltipTrigger } from "@domainstack/ui/responsive-tooltip";
import { Spinner } from "@domainstack/ui/spinner";
interface ReportSectionProps {
  title: string;
  description?: string;
  help?: string;
  icon?: React.ElementType;
  slug?: string;
  accent?: "blue" | "purple" | "green" | "orange" | "pink" | "cyan" | "slate";
  isLoading?: boolean;
  /** Optional actions to render in the top-right of the section header */
  headerActions?: React.ReactNode;
  children?: React.ReactNode;
}
export function ReportSection(t0) {
  const $ = _c(46);
  const {
    title,
    description,
    help,
    icon,
    slug,
    accent: t1,
    isLoading,
    headerActions,
    children
  } = t0;
  const accent = t1 === undefined ? "slate" : t1;
  const IconComponent = icon;
  const t2 = slug ?? title;
  let t3;
  if ($[0] !== t2) {
    let t4;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = /[^a-z0-9-]/g;
      $[2] = t4;
    } else {
      t4 = $[2];
    }
    t3 = t2.toLowerCase().replace(/\s+/g, "-").replace(t4, "");
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const computedSlug = t3;
  const headerId = `section-header-${computedSlug}`;
  const contentId = `section-content-${computedSlug}`;
  const t4 = `var(--accent-${accent})`;
  let t5;
  if ($[3] !== t4) {
    t5 = {
      "--glow-color": t4
    };
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const t6 = t5 as React.CSSProperties;
  let t7;
  if ($[5] !== t6) {
    t7 = <div aria-hidden={true} className="pointer-events-none absolute -inset-x-8 -top-8 h-24 accent-glow opacity-30 blur-2xl" style={t6} />;
    $[5] = t6;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== IconComponent) {
    t8 = IconComponent && <Icon size="sm" className="rounded-full"><IconComponent /></Icon>;
    $[7] = IconComponent;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== title) {
    t9 = <span className="text-base">{title}</span>;
    $[9] = title;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== help || $[12] !== title) {
    t10 = help && <ResponsiveTooltip><ResponsiveTooltipTrigger nativeButton={false} render={<span role="img" aria-label={`More info about ${title}`}><IconInfoCircle className="size-3.5 opacity-60" aria-hidden={true} /></span>} /><ResponsiveTooltipContent>{help}</ResponsiveTooltipContent></ResponsiveTooltip>;
    $[11] = help;
    $[12] = title;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== t10 || $[15] !== t9) {
    t11 = <CardTitle className="flex items-center gap-2">{t9}{t10}</CardTitle>;
    $[14] = t10;
    $[15] = t9;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== description || $[18] !== help) {
    t12 = (description || help) && <CardDescription className="sr-only">{description}</CardDescription>;
    $[17] = description;
    $[18] = help;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== t11 || $[21] !== t12) {
    t13 = <div className="min-w-0 flex-1">{t11}{t12}</div>;
    $[20] = t11;
    $[21] = t12;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== isLoading) {
    t14 = isLoading && <div className="mr-2 flex items-center gap-2 text-xs text-muted-foreground"><Spinner className="size-5" /><span className="sr-only">Loading</span></div>;
    $[23] = isLoading;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== headerActions || $[26] !== t14) {
    t15 = <div className="ml-auto flex items-center gap-3">{t14}{headerActions}</div>;
    $[25] = headerActions;
    $[26] = t14;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  let t16;
  if ($[28] !== t13 || $[29] !== t15 || $[30] !== t8) {
    t16 = <div className="flex w-full items-center gap-2 text-left">{t8}{t13}{t15}</div>;
    $[28] = t13;
    $[29] = t15;
    $[30] = t8;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] !== headerId || $[33] !== t16) {
    t17 = <div className="relative"><div className="p-5" id={headerId}>{t16}</div></div>;
    $[32] = headerId;
    $[33] = t16;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  let t18;
  if ($[35] !== children || $[36] !== contentId) {
    t18 = children && <div id={contentId}><CardContent className="space-y-2 px-5 pt-0 pb-5">{children}</CardContent></div>;
    $[35] = children;
    $[36] = contentId;
    $[37] = t18;
  } else {
    t18 = $[37];
  }
  let t19;
  if ($[38] !== t17 || $[39] !== t18 || $[40] !== t7) {
    t19 = <Card className="relative gap-0 overflow-hidden rounded-xl border border-black/10 bg-background/60 py-0 shadow-2xl shadow-black/10 dark:border-white/10">{t7}{t17}{t18}</Card>;
    $[38] = t17;
    $[39] = t18;
    $[40] = t7;
    $[41] = t19;
  } else {
    t19 = $[41];
  }
  let t20;
  if ($[42] !== computedSlug || $[43] !== headerId || $[44] !== t19) {
    t20 = <section id={computedSlug} aria-labelledby={headerId} className="scroll-mt-[calc(var(--section-nav-height)+var(--scroll-padding))] border-none md:scroll-mt-[calc(var(--header-height)+var(--section-nav-height)+var(--scroll-padding))]">{t19}</section>;
    $[42] = computedSlug;
    $[43] = headerId;
    $[44] = t19;
    $[45] = t20;
  } else {
    t20 = $[45];
  }
  return t20;
}